import { isAnalyticsAllowed } from '@lumapps/analytics/ducks/selectors';
import { isFeatureEnabled } from '@lumapps/features';
import { isInstanceSuperAdmin } from '@lumapps/permissions';
import { createSelector } from '@lumapps/redux/reselect';

import { COVEO_INDEXING_FEATURE_TOKEN } from '../constants';

export const hasCoveoIndexingEnabled = isFeatureEnabled(COVEO_INDEXING_FEATURE_TOKEN);

export const canViewSearchAnalytics = createSelector(
    isInstanceSuperAdmin,
    isAnalyticsAllowed,
    hasCoveoIndexingEnabled,
    (isInstanceAdmin = false, isAnalyticsReadAllowed = false, hasCoveo = false) => {
        // When Coveo indexing is enabled, nobody can see search analytics
        if (hasCoveo) {
            return false;
        }
        // Otherwise, instance admin or analytics read permission can see it
        return isInstanceAdmin || isAnalyticsReadAllowed;
    },
);
